__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "veloce";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/animations", "12.2.2", function() { return function() { return __webpack_require__(82458); }; }, 1);
			register("@angular/common", "12.2.2", function() { return function() { return __webpack_require__(40093); }; }, 1);
			register("@angular/core", "12.2.2", function() { return function() { return __webpack_require__(91477); }; }, 1);
			register("@angular/forms", "12.2.2", function() { return function() { return __webpack_require__(59298); }; }, 1);
			register("@angular/platform-browser", "12.2.2", function() { return function() { return __webpack_require__(4919); }; }, 1);
			register("@veloce/elements", "1.3.0", function() { return function() { return __webpack_require__(91014); }; }, 1);
			register("ngx-bootstrap/tooltip", "5.6.1", function() { return function() { return __webpack_require__(86028); }; }, 1);
			register("rxjs", "7.3.0", function() { return function() { return __webpack_require__(95778); }; }, 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};